var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5575 9.07651L5.63402 41.7624C5.33255 42.2846 5.17359 42.8768 5.17306 43.4797C5.17252 44.0827 5.33044 44.6751 5.63098 45.1978C5.93152 45.7205 6.36414 46.155 6.8855 46.4579C7.40685 46.7607 7.99863 46.9213 8.60156 46.9234H46.4484C47.0514 46.9213 47.6431 46.7607 48.1645 46.4579C48.6859 46.155 49.1185 45.7205 49.419 45.1978C49.7196 44.6751 49.8775 44.0827 49.8769 43.4797C49.8764 42.8768 49.7174 42.2846 49.416 41.7624L30.4925 9.07651C30.1933 8.55368 29.7613 8.11918 29.2402 7.81699C28.7191 7.5148 28.1274 7.35565 27.525 7.35565C26.9226 7.35565 26.3309 7.5148 25.8098 7.81699C25.2887 8.11918 24.8567 8.55368 24.5575 9.07651Z",
    fill: "#FF8E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.525 22.8391V31.4407",
    stroke: "white",
    strokeWidth: 2.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.525 41.3324C28.7126 41.3324 29.6754 40.3696 29.6754 39.182C29.6754 37.9944 28.7126 37.0316 27.525 37.0316C26.3374 37.0316 25.3746 37.9944 25.3746 39.182C25.3746 40.3696 26.3374 41.3324 27.525 41.3324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.e31ff18ff55e73b6cd4dc7b76fd7c190.svg";
export { ForwardRef as ReactComponent };